import React from 'react';
import styles from './style.css';
import FormerEmployer from '../FormerEmployer/FormerEmployer';
import Heading from '../Typography/Heading/Heading';

const RolloverInstitutionHeader = () => {
  const headingCopy =
    "Select the institution that holds the account you'd like to roll over from";
  return (
    <div className="build-institution-header" id="build-institution-header">
      <Heading text={headingCopy} />
      <FormerEmployer />
      <style jsx>{styles}</style>
    </div>
  );
};

export default RolloverInstitutionHeader;
